var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n  font-family: \"iconfont\"; /* Project id  */\r\n  src: url(" + escape(require("./iconfont.ttf?t=1620643511304")) + ") format('truetype');\r\n}\r\n\r\n.iconfont {\r\n  font-family: \"iconfont\" !important;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.icon-insertcolumn:before {\r\n  content: \"\\E753\";\r\n}\r\n\r\n.icon-insertrow:before {\r\n  content: \"\\E754\";\r\n}\r\n\r\n.icon-hide:before {\r\n  content: \"\\E76B\";\r\n}\r\n\r\n.icon-drag:before {\r\n  content: \"\\E61D\";\r\n}\r\n\r\n", ""]);

// exports
